import { useEffect } from "react";

/** Klasse am `<html>`, solange ein Sheet der Vorgangsansicht offen ist. */
export const SHEET_KLASSE = "vg4m-sheet-offen";

/**
 * Setzt `SHEET_KLASSE`, solange `offen` — der Melde-Knopf tritt dann zurück
 * (`tickets.css`), sonst läge er über Kacheln und Schließen-Kreuz.
 * Gezählt, damit zwei Sheets sich die Klasse nicht gegenseitig wegnehmen.
 */
let offeneSheets = 0;
export function useSheetKlasse(offen: boolean): void {
    useEffect(() => {
        if (!offen) return;
        offeneSheets += 1;
        document.documentElement.classList.add(SHEET_KLASSE);
        return () => {
            offeneSheets = Math.max(0, offeneSheets - 1);
            if (offeneSheets === 0) document.documentElement.classList.remove(SHEET_KLASSE);
        };
    }, [offen]);
}
